export function getColumnTemmplate(columns) {
  let template = '';

  Object.keys(columns).forEach((c) => {
    if (columns[c].show) {
      template += columns[c].width ? `${columns[c].width} ` : '1fr ';
    }
  });

  return template;
}

export function calculateColumnWidths(columns, frameWidth = 350) {
  const cols = Object.values(columns);

  const staticWidth = 30 + 30 + 10 + 20;
  const padding = 6;
  const visibleColumns = cols.filter((col) => col.show && col.canHide);
  const fixedWidthTotal = visibleColumns
    .filter((col) => col.width)
    .reduce((total, col) => total + parseInt(col.width, 10) + padding, 0);
  const minimumVariableWidthTotal =
    visibleColumns.reduce((total, col) => total + padding, 0) + padding;

  const maxNameWidth = 1000;
  const minNameWidth = 75;

  let nameWidth =
    frameWidth -
    (fixedWidthTotal +
      staticWidth +
      minimumVariableWidthTotal +
      visibleColumns.length * 25);

  if (nameWidth < minNameWidth) {
    nameWidth = minNameWidth;
  } else if (nameWidth > maxNameWidth) {
    nameWidth = maxNameWidth;
  }

  const variableShown = cols.filter(
    (col) => col.canHide && col.show && !col.width
  ).length;
  const variableTotal = cols.filter((col) => col.canHide && !col.width).length;
  const fractional = variableShown ? variableTotal / variableShown : 0;

  const widths = [
    `${nameWidth}px`,
    ...cols
      .filter((col) => col.show && col.canHide)
      .map((col) => col.width || `${fractional}fr`),
    ...(!fractional ? ['1fr'] : []),
  ];

  return widths.join(' ');
}
